const visualUrl = '/visual';

export default visualUrl;
